import { Component, inject, signal } from '@angular/core';
import { SliderComponent } from "./slider/components/slider.component";
import { AboutusHomeComponent } from "./aboutus-home/Components/aboutus-home.component";
import { SponsorComponent } from "./sponsor/Component/sponsor.component";

import { ContactusHomeComponent } from "./contactus-home/Component/contactus-home.component";
import { BlogSliderComponent } from "./blog-slider/blog-slider.component";
import { FeatureComponent } from "./subSocieties/Components/feature.component";
import { DoctorSliderComponent } from './doctor-slider/Components/doctor-slider.component';
import { AuthService } from '../shared/service/auth.service';
import { ModalComponent } from '../pages/membership-modal/modal.component';
import { loginService } from '../pages/login/Services/login.service';
import { imageService } from '../shared/service/image.service';
import { AdsComponent } from "../shared/Componet/ads/ads.component";
import { AnnouncementService } from '../shared/service/announcement.service';
import { SlicePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { SharedModule } from '../shared/Module/shared.module';
import { SharedSponserService } from './sponsor/Services/shareSponser.service';
import { AdsService } from '../shared/service/ads.service';

@Component({
  selector: 'app-home',
  imports: [SliderComponent, AboutusHomeComponent, SponsorComponent, SharedModule,
    DoctorSliderComponent, ContactusHomeComponent, BlogSliderComponent, FeatureComponent, ModalComponent, AdsComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {

  isMember: boolean = false
  isLoggedIn = false;
  Announcements = signal<any[]>([]);
  sponsers = signal<any[]>([]);
  private subs = new Subscription();

  private authService = inject(AuthService);
  private SharedSponserService = inject(SharedSponserService)

  private imageService = inject(imageService)
  private loginService = inject(loginService)
  private AnnouncementService = inject(AnnouncementService)
  private AdsService = inject(AdsService)

  ngOnInit() {
    this.sponsers = this.SharedSponserService.getBronzeSponsors()

    // console.log(" this.sponsers in home", this.sponsers())

    const userId = localStorage.getItem("userId")
    const token = localStorage.getItem("token")
    const userName = localStorage.getItem("userName");

    if (token && !userId) {
      localStorage.setItem('token', token);
      this.loginService.GetCurrentUser().subscribe({
        next: (res: any) => {
          localStorage.setItem("userId", res.value.id);
          localStorage.setItem("isMember", res.value.isMember);
          localStorage.setItem("userName", res.value.userName);
          localStorage.setItem("isAdmin", res.value.isAdmin);
        }
      })

      // console.log('reload called');
      // window.location.reload()

    }
    // console.log("this.isMember", this.isMember)
    // console.log("isClosedBefore", isClosedBefore)

    if (token && userId && userName) {
      this.authService.setLoggedIn();
      // this.imageService.loadUserImage(userName);
    }

    this.getAnnouncemnts()

  }

  ngAfterViewInit() {

    setTimeout(() => {
      this.isMember = localStorage.getItem("isMember") === "true";
      const sub = this.authService.loginState$.subscribe((state) => {
        this.isLoggedIn = state;
        // console.log("this.isLoggedIn", this.isLoggedIn)
        // console.log("HEADER LOGIN STATE =", state);
      });
      this.subs.add(sub);
      const isClosedBefore = localStorage.getItem('membershipModalClosed') === "true";
      if (!this.isMember && !isClosedBefore && this.isLoggedIn) {
        this.showMembershipModal();
      }
    }, 5000);

  }

  getAnnouncemnts() {
    const sub = this.AnnouncementService.getDetectedAnnouncements({
      PageId: 6,
      SectionId: 5
    }).subscribe({
      next: (res: any) => {
        // this.Announcements.set(res.value)
        this.Announcements.set(this.AdsService.getDisplayedAds(res.value, 3));
      }
    })

    this.subs.add(sub);
  }

  showMembershipModal() {
    const modalElement = document.getElementById('membershipModal');
    if (modalElement) {
      const modal = new (window as any).bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  // get displayedAds() {
  //   const ads = this.Announcements()?.slice(0, 3) ?? [];

  //   const defaultAdsCount = 3 - ads.length;

  //   const defaultAds = Array.from({ length: defaultAdsCount }).map(() => ({
  //     isDefault: true
  //   }));

  //   return [...ads, ...defaultAds];
  // }


  ngOnDestroy(): void {
    this.subs.unsubscribe();   // unsubscribe from all
  }
}
